<div class="modal-content">
    <div class="modal-header">
        <h5 class="modal-title">UPSI Sharer</h5>
        <button aria-label="Close" class="close" type="button" (click)="activeModal.dismiss('dismiss')">
            <i class="fa fa-times"></i>
        </button>
    </div>
    <div class="modal-body">

        <section class="card">
            <div class="card-header">
                <span class="cat__core__title">
                    <strong>UPSI Emails Log</strong>
                </span>

            </div>


            <div class="card-block datatable-card-block">
                <div class="row">
                    <div class="col-md-12">
                        <div class="margin-bottom-50">
                            <div class="table-responsive">


                                <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger"
                                    class="table table-hover compact cell-border nowrap stripe" id="CsvUploadtable"
                                    style="cursor: pointer;">
                                    <thead>
                                        <tr>
                                            <th style="min-width:200px">Subject</th>
                                            <th style="min-width:200px">To </th>
                                            <th style="min-width:200px">Cc </th>
                                            <th style="min-width:200px">Sent Date</th>
                                            <th style="min-width:100px">Text</th>
                                            <th style="display: none">Sent Date</th>

                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let d of EmailsLogs; let count=index" style="line-height: 25px;">
                                            <td style="min-width:200px">{{d.Subject }}</td>
                                            <td style="min-width:200px">
                                                <li *ngFor="let eTo of d.To"> {{eTo}}</li>
                                            </td>
                                            <td style="min-width:200px">
                                                <li *ngFor="let eCc of d.Cc"> {{eCc}}</li>
                                            </td>
                                            <td style="min-width:200px">
                                                {{d.CreatedDate | date : "dd-MM-y"}}
                                            </td>

                                            <td style="min-width:100px">

                                                <button type="button" (click)="viewEmails(d.EmailText, d.CreatedDate)"
                                                    class="btn-sm btn btn-warning" title="View">
                                                    <span class="fa fa-eye"></span>

                                                </button>
                                            </td>
                                            <td style="display: none">
                                                {{d.CreatedDate | date : "yMMddHHmm"}}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>




            <div class="modal" id="ViewHtmlEmail" tabindex="-1" role="dialog" data-backdrop="static"
                data-keyboard="false" aria-labelledby="" aria-hidden="true">
                <div class="modal-dialog  modal-lg" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title" id="myModalLabelForDeletion">
                                Email Text (Sent Date :- <span id="sentdate"></span> )</h5>
                            <button aria-label="Close" class="close" data-dismiss="modal" type="button">
                                <i class="fa fa-times"></i>
                            </button>

                        </div>
                        <div class="modal-body">
                            <div class="row">
                                <div class="col-sm-12" id="htmldata">

                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">

                            <button type="button" class="btn btn-sm btn-primary" data-dismiss="modal">
                                <i class="fa fa-times"></i>&nbsp;Ok</button>
                        </div>
                    </div>
                </div>
            </div>





        </section>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-sm btn-primary" (click)="activeModal.dismiss('dismiss')">
            <i class="fa fa-times"></i>&nbsp;Cancel</button>
    </div>
</div>
<app-alert></app-alert>